import React from 'react';
import { Icon } from 'ui';

const EstimatedLessonCompletionTime = ({
  estimatedMinutesToComplete,
  ...props
}) => (
  <div
    className={`c-brand-gray h-c-gray-darker f-sh-0 ${props.additionalStyle}`}
  >
    <Icon name="clock" />{' '}
    {`${estimatedMinutesToComplete} ${t('time_units.minutes.abbreviation')}`}
  </div>
);

export default EstimatedLessonCompletionTime;
